const SHIPPING_QUOTE_TYPES = Object.freeze({
  EXTENDED: 'extended',
  PREORDER: 'preorder',
  STANDARD: 'standard',
});

const EXTENDEND_SHIPPING_QUOTE_TYPES = Object.freeze([
  SHIPPING_QUOTE_TYPES.EXTENDED,
  SHIPPING_QUOTE_TYPES.PREORDER,
]);

const EXTERNAL_ORDER_SOURCE_APPS = Object.freeze({
  ONBOARDING: 'onboarding',
  TCO: 'tco',
  QSR_HARDWARE_FLOW: 'qsr-hardware-flow',
  SHOP_HARDWARE_FLOW: 'shop-hardware-flow',
});

const DISPLAY_MODES = Object.freeze({
  DASHBOARD: 'dashboard',
});

const SEARCH_PARAM_NAMES = Object.freeze({
  REFERER: 'ref',
  MODEL_VIEW: 'model_view',
  MODEL_NUMBER: 'model_number',
  MODE: 'mode',
  INITIAL_PROGRESS: 'initial_progress',
  PROGRESS: 'progress',
  SOURCE: 'source',
});

const DASHBOARD_SEARCH_PARAMS = Object.freeze({
  COMPLETED_SETUP_TASK: {
    KEY: 'completedSetupTask',
    VALUES: {
      BUY_HARDWARE: 'buyHardware',
    },
  },
});

const QSR_FLOW_PARAMS = Object.freeze({
  FROM_GOLDEN_PATH_SETUP: {
    KEY: 'fromGoldenPathSetup',
    VALUES: {
      TRUE: 'true',
    },
  },
  SETUP_GUIDE_ITEM: {
    KEY: 'setupGuideItem',
    VALUES: {
      BUY_HARDWARE: 'BUY_HARDWARE',
    },
  },
  STEP: {
    KEY: 'step',
    VALUES: {
      BUY_HARDWARE: 'BUY_HARDWARE',
    },
  },
});

const R4X_BASE_PRODUCT_KEYS = ['r4', 'r41', 'r42'];

const CHECKOUT_ROUTES = Object.freeze({
  CART: '/cart',
  INFORMATION: '/information',
  SHIPPING_METHOD: '/shipping_method',
  PAYMENT_OPTION: '/payment_option',
  OFFER_SELECT: '/offer_select',
  FINANCE_APP: '/finance_app',
  PAYMENT: '/payment',
  REVIEW: '/review',
  COMPLETE: '/complete',
});

const DASHBOARD_MODE_STEP_LEVELS = [
  CHECKOUT_ROUTES.CART,
  CHECKOUT_ROUTES.INFORMATION,
  CHECKOUT_ROUTES.SHIPPING_METHOD,
  CHECKOUT_ROUTES.PAYMENT_OPTION,
  CHECKOUT_ROUTES.OFFER_SELECT,
  CHECKOUT_ROUTES.FINANCE_APP,
  CHECKOUT_ROUTES.PAYMENT,
  CHECKOUT_ROUTES.REVIEW,
  CHECKOUT_ROUTES.COMPLETE,
];

/**
 * From category taxons
 * Spree::Taxon.where("sq_translation_key like ?", "%categories__%").pluck(:sq_translation_key)
 */
const PRODUCT_CATEGORIES = Object.freeze({
  BUNDLES: 'categories__bundles',
  BUNDLES__HW_AND_PAYMENT_PROCESSING_BUNDLES:
    'categories__bundles__hw_and_payment_processing_bundles',
  BUNDLES__HW_AND_SW_BUNDLES: 'categories__bundles__hw_and_sw_bundles',
  BUNDLES__HW_BUNDLES: 'categories__bundles__hw_bundles',
  BUNDLES__HW_SW_AND_PAYMENT_PROCESSING_BUNDLES:
    'categories__bundles__hw_sw_and_payment_processing_bundles',
  HW_ACCESSORIES: 'categories__hw_accessories',
  HW_ACCESSORIES__BARCODE_SCANNERS:
    'categories__hw_accessories__barcode_scanners',
  HW_ACCESSORIES__CASES: 'categories__hw_accessories__cases',
  HW_ACCESSORIES__CASH_DRAWERS: 'categories__hw_accessories__cash_drawers',
  HW_ACCESSORIES__OTHER: 'categories__hw_accessories__other',
  HW_ACCESSORIES__PRINTERS: 'categories__hw_accessories__printers',
  HW_ACCESSORIES__PRINTERS__KITCHEN_PRINTERS:
    'categories__hw_accessories__printers__kitchen_printers',
  HW_ACCESSORIES__PRINTERS__LABEL_PRINTERS:
    'categories__hw_accessories__printers__label_printers',
  HW_ACCESSORIES__PRINTERS__RECEIPT_PRINTERS:
    'categories__hw_accessories__printers__receipt_printers',
  HW_ACCESSORIES__PRINTER_PAPER: 'categories__hw_accessories__printer_paper',
  HW_ACCESSORIES__PRINTER_PAPER__KITCHEN_PRINTERS:
    'categories__hw_accessories__printer_paper__kitchen_printers',
  HW_ACCESSORIES__PRINTER_PAPER__LABEL_PRINTERS:
    'categories__hw_accessories__printer_paper__label_printers',
  HW_ACCESSORIES__PRINTER_PAPER__RECEIPT_PRINTERS:
    'categories__hw_accessories__printer_paper__receipt_printers',
  HW_ACCESSORIES__PRINTER_PAPER__SQUARE_TERMINAL:
    'categories__hw_accessories__printer_paper__square_terminal',
  HW_ACCESSORIES__REPLACEMENT_PARTS:
    'categories__hw_accessories__replacement_parts',
  HW_ACCESSORIES__STANDS: 'categories__hw_accessories__stands',
  HW_HERO_PRODUCTS: 'categories__hw_hero_products',
  HW_HERO_PRODUCTS__READER_FOR_CONTACTLESS_AND_CHIP:
    'categories__hw_hero_products__reader_for_contactless_and_chip',
  HW_HERO_PRODUCTS__READER_FOR_MAGSTRIPE:
    'categories__hw_hero_products__reader_for_magstripe',
  HW_HERO_PRODUCTS__REGISTER: 'categories__hw_hero_products__register',
  HW_HERO_PRODUCTS__STAND_MOUNT: 'categories__hw_hero_products__stand_mount',
  HW_HERO_PRODUCTS__HANDHELD: 'categories__hw_hero_products__handheld',
  HW_HERO_PRODUCTS__TERMINAL: 'categories__hw_hero_products__terminal',
  PAYMENT_PROCESSING: 'categories__payment_processing',
  SOFTWARE: 'categories__software',
  SOFTWARE__BANKING: 'categories__software__banking',
  SOFTWARE__COMMERCE: 'categories__software__commerce',
  SOFTWARE__CUSTOMERS: 'categories__software__customers',
  SOFTWARE__POS_SW: 'categories__software__pos_sw',
  SOFTWARE__STAFF: 'categories__software__staff',
});

const INELIGIBLE_REASONS = Object.freeze({
  HAS_SUBSCRIBED: 'has_subscribed',
  HAS_PURCHASED: 'has_purchased',
  DIFFERENT_COUNTRY: 'different_country',
  NOT_LOGGED_IN: 'not_logged_in',
  NO_DISCLAIMER: 'no_disclaimer',
});

// derived from all distinct values in the spree_credit_cards.cc_type column
const CARD_BRANDS = Object.freeze({
  AMEX: 'AMERICAN_EXPRESS',
  DISCOVER: 'DISCOVER',
  JCB: 'JCB',
  MASTERCARD: 'MASTERCARD',
  VISA: 'VISA',
  UNION_PAY: 'UNION_PAY',
  DISCOVER_DINERS: 'DISCOVER_DINERS',
  OTHER: 'OTHER',
  SQUARE_GIFT_CARD_V2: 'SQUARE_GIFT_CARD_V2',
  OTHER_BRAND: 'OTHER_BRAND',
  CHINA_UNIONPAY: 'CHINA_UNIONPAY',
  SQUARE_GIFT_CARD: 'SQUARE_GIFT_CARD',
});

const STORE_CODES = Object.freeze({
  US: 'US',
});

const CARD_INTENT = Object.freeze({
  CHARGE: 'CHARGE',
  CHARGE_AND_STORE: 'CHARGE_AND_STORE',
});

// https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options/#override-an-html-element
const DATADOG_PRIVACY_LEVELS = Object.freeze({
  ALLOW: 'allow',
  MASK: 'mask',
  HIDDEN: 'hidden',
  MASK_USER_INPUT: 'mask-user-input',
});

export {
  DASHBOARD_SEARCH_PARAMS,
  QSR_FLOW_PARAMS,
  SEARCH_PARAM_NAMES,
  SHIPPING_QUOTE_TYPES,
  EXTENDEND_SHIPPING_QUOTE_TYPES,
  R4X_BASE_PRODUCT_KEYS,
  EXTERNAL_ORDER_SOURCE_APPS,
  DISPLAY_MODES,
  INELIGIBLE_REASONS,
  PRODUCT_CATEGORIES,
  DASHBOARD_MODE_STEP_LEVELS,
  CHECKOUT_ROUTES,
  CARD_BRANDS,
  CARD_INTENT,
  DATADOG_PRIVACY_LEVELS,
  STORE_CODES,
};
